export default __webpack_public_path__ + "static/media/Civil Engineering.1851c589.pdf";